import { combineReducers } from 'redux';

import { ConnectedActionHandlerMap as gridReducer, namespace as gridNamespace } from './grid/alerts.grid.reducer';
import { ConnectedActionHandlerMap as detailsReducer, namespace as detailsNamespace } from './details/alerts.details.reducer';

export const combinedReducer = combineReducers({
  [gridNamespace]: gridReducer,
  [detailsNamespace]: detailsReducer,
});

export { namespace } from './alerts.reducer.metadata';
